import axios from "axios";
import { isNullOrEmpty } from "../utils";
import createAxiosErrorHandler from './errorHandler';

let axiosInstance;

const setAxiosInstance = (config = {}) => {
  if (isNullOrEmpty(axiosInstance)) {
    axiosInstance = axios.create();
    configureAxiosInterceptors(axiosInstance);
  }

  if (config.baseURL) {
    axiosInstance.defaults.baseURL = config.baseURL;
  }
  if (config.Authorization) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${config.Authorization}`;
  }

  return axiosInstance;
};

const configureAxiosInterceptors = (instance) => {
  // Use the shared error handler which can clear auth on 401 and show notifications
  const handler = createAxiosErrorHandler(instance);
  instance.interceptors.response.use(
    (response) => response,
    (error) => handler(error)
  );
};

// Optionally, add request interceptors here

export {
  setAxiosInstance,
  axiosInstance,
};
